import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Phone, Leaf, Heart, ShieldCheck } from 'lucide-react';
export function HoneyPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-351">
      <Header data-id="element-352" />

      {/* Hero Section with Forest Background */}
      <section className="relative pt-32 pb-24 overflow-hidden" style={{
      backgroundImage: 'linear-gradient(rgba(13, 18, 29, 0.55), rgba(13, 18, 29, 0.75)), url(https://cdn.magicpatterns.com/uploads/eLgKy3Qav9dc5TFrGCULbj/image_%2822%29.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-353">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-354">
          <a href="/saint-lucia" className="inline-flex items-center text-white/90 hover:text-white transition-colors mb-12 drop-shadow" data-id="element-355">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-356" />
            Back to Saint Lucia
          </a>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[60vh]" data-id="element-357">
            {/* Text content */}
            <div className="text-center lg:text-left" data-id="element-358">
              <div className="inline-block px-4 py-1.5 rounded-full bg-amber-400/20 backdrop-blur-sm border border-amber-300/40 text-amber-200 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-359">
                <span className="inline-flex items-center gap-2" data-id="element-360">
                  <Leaf className="w-4 h-4" data-id="element-361" />
                  100% Natural • From Saint Lucia
                </span>
              </div>

              <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight drop-shadow-2xl" data-id="element-362">
                Pure Honey,
                <br data-id="element-363" />
                <span className="text-amber-300" data-id="element-364">Pure Nature.</span>
              </h1>

              <p className="text-xl text-white/95 mb-8 leading-relaxed drop-shadow-lg max-w-xl" data-id="element-365">
                Authentic, real natural pure honey — untouched by additives or
                processing — harvested from the pristine tropical landscapes of
                Saint Lucia.
              </p>

              <a href="tel:+13475836724" className="inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold rounded-full text-slate-900 bg-amber-300 hover:bg-amber-200 transition-colors shadow-2xl shadow-amber-500/30" data-id="element-366">
                <Phone className="w-5 h-5" data-id="element-367" />
                Order: 1 (347) 583-6724
              </a>
            </div>

            {/* Honey Label */}
            <div className="relative flex justify-center lg:justify-end" data-id="element-368">
              <div className="absolute -inset-8 bg-amber-400/30 blur-3xl rounded-full" data-id="element-369" />
              <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-370">
                <img src="https://cdn.magicpatterns.com/uploads/rv6LLeJAANne3QdotvL8KB/Honey_Label-01.png" alt="Nature's Worker Bees Produce - Natural Honey from St. Lucia" className="max-w-full w-full lg:max-w-xl h-auto rounded-2xl shadow-2xl ring-4 ring-amber-200/30" data-id="element-371" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 relative" data-id="element-372">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-373">
          <div className="bg-white/5 backdrop-blur rounded-3xl border border-amber-500/20 p-10 md:p-14" data-id="element-374">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-375">
              From Our Hives to Your Home
            </h2>

            <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-376">
              <p data-id="element-377">
                <span className="text-amber-300 font-semibold" data-id="element-378">
                  Twice Bourne Holdings Ltd
                </span>{' '}
                proudly brings the pure essence of nature to homes across the
                United States, with a special focus on supporting the wellness
                of our elderly community.
              </p>

              <p data-id="element-379">
                We supply authentic, real natural pure honey — untouched by
                additives or processing — harvested from the pristine tropical
                landscapes of Saint Lucia. This exceptional honey is sourced
                through our close collaboration with{' '}
                <span className="text-amber-300 font-semibold" data-id="element-380">
                  Nature's Worker Bees Produce
                </span>{' '}
                of Saint Lucia, West Indies, ensuring the highest standards of
                quality and natural goodness.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="pb-20" data-id="element-381">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-382">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-383">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-384">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-385">
                <Leaf className="w-7 h-7 text-amber-300" data-id="element-386" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-387">
                100% Natural
              </h3>
              <p className="text-slate-400" data-id="element-388">
                No additives, no processing — just pure honey straight from the
                tropics.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-389">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-390">
                <ShieldCheck className="w-7 h-7 text-amber-300" data-id="element-391" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-392">
                Trusted Source
              </h3>
              <p className="text-slate-400" data-id="element-393">
                Sourced from Nature's Worker Bees Produce in Saint Lucia, West
                Indies.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-394">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-395">
                <Heart className="w-7 h-7 text-amber-300" data-id="element-396" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-397">
                Wellness Focused
              </h3>
              <p className="text-slate-400" data-id="element-398">
                Special focus on supporting the wellness of our elderly
                community.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="pb-24" data-id="element-399">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-400">
          <div className="bg-gradient-to-br from-amber-500/20 via-amber-600/10 to-slate-900/40 backdrop-blur rounded-3xl border border-amber-400/30 p-12 text-center" data-id="element-401">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-402">
              Order Your Honey Today
            </h2>
            <p className="text-lg text-slate-300 mb-8" data-id="element-403">
              To place your order or make inquiries, contact us today.
            </p>
            <a href="tel:+13475836724" className="inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold rounded-full text-slate-900 bg-amber-300 hover:bg-amber-200 transition-colors shadow-2xl shadow-amber-500/30" data-id="element-404">
              <Phone className="w-6 h-6" data-id="element-405" />1 (347) 583-6724
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-406" />
    </div>;
}